var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',_vm._g(_vm._b({attrs:{"size":"mini","page-size":_vm.pageSizeLocal,"page-sizes":[10, 20, 50, 100],"layout":_vm.filterLayout}},'el-pagination',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }